// check if a given id exists in a list of nodes returned from gql query

type Data = {
  id?: string | null | undefined;
};

const checkItemExists = (id: string, data: Data[]) => {
  if (!id || !data) {
    return false;
  }

  return data.some((item) => item.id === id);
};

export const checkIfIdExistsInData = <T extends Data>(
  id: string | null | undefined,
  data: T[] | undefined
): string | 'invalid' | undefined => {
  if (!id || !data) {
    return undefined;
  }

  const itemExists = checkItemExists(id, data);

  let activeItemId = '';

  if (!itemExists) {
    activeItemId = 'invalid';
  } else if (id && itemExists) {
    activeItemId = id;
  }

  return activeItemId;
};
